export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14025.df38a9be.jpg";